
<app-content-body class="h-100 px-2" >
  <div *ngIf="showIfNonHosted()" class="d-flex justify-content-center align-items-center vh-100">
    <div class="shadow-lg card-error p-5 d-flex flex-column justify-content-center card-container rounded-5 mb-5" style="max-width: 40%;height: 40%;"> 
      <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
        <h3 class="headline mb-4 mt-4 fs-4">Thank You for Your Request!</h3>
        <p class="mb-3 fs-6">
          Your quotation request has been successfully submitted. A member of our sales team will reach out to you soon.
          If you need immediate assistance, feel free to contact us at 
          <a href="mailto:sales@alachisoft.com">sales&#64;alachisoft.com</a>.
        </p>
      </div>
    </div>
  </div>
<div *ngIf="hideNonHostedEnvironmentMenus()" class="d-flex justify-content-center align-items-center vh-100">
  <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
  </div>
</div>

  <!-- <div class="inner-container" ng-if="hideNonHostedEnvironmentMenus()" ng-cloak>
    <div class="container-fluid  py-1">

      <div class="d-flex flex-row mt-5" *ngIf="hideNonHostedEnvironmentMenus()">
          <div class="col">
              <div class="content-header d-flex justify-content-between">
                  <div class="d-flex flex-row align-items-center">
                      <fa-icon *ngIf='faCloud' [icon]='faCloud' class="align-self-center"></fa-icon>
                      <p class="ms-2 title">{{title}}</p>
                  </div>
              </div>
              <p class="content-header title" style="margin-left: 30px;">{{nextHeader}}</p>
      </div>
      </div>
      <div class="d-flex flex-row mt-3" *ngIf="hideNonHostedEnvironmentMenus()">
        <div class="text-start">
        <a class="btn  wizard-button ">Buy NCache </a>
      </div>
      <div >
        <a class="btn  wizard-button underline">Create Quotation </a>
      </div>
      <div >
        <a class="btn  wizard-button ">Preview Quotation </a>
      </div>
      </div>
      <div class="mt-4 flex-row col-12 row">
          <div class="col-sm-6">
            <div class="border">
              <div class="text-start border-bottom p-3 d-flex justify-content-between align-items-center bg-blue">
                <h6 class="d-inline my-auto">Company</h6>
              </div>
              <div>
                <div class="card-body  d-flex flex-column subscription-body p-3">
                  <div class="row ">
                    <div class="col-sm-2 fw-bold lh-lg ">Name:</div>
                    <div class="col-sm-4 text-end">
                      {{ userDetails?.companyDetails?.name }}
                    </div>
          
                    <div class="col-sm-2 fw-bold lh-lg">State/Region:</div>
                    <div class="col-sm-4 text-end">
                      {{ userDetails?.companyDetails?.state }}
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-sm-2 fw-bold lh-lg">Website:</div>
                    <div class="col-sm-4 text-end">
                      {{ userDetails?.companyDetails?.url }}
                    </div>
                    <div class="col-sm-2 fw-bold lh-lg">Zip/Postal Code:</div>
                    <div class="col-sm-4 text-end">
                      {{ userDetails?.companyDetails.postalCode }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg">Street:</div>
                    <div class="col-sm-4 text-end">{{userDetails?.companyDetails?.address}}</div>
                    <div class="col-sm-2 fw-bold lh-lg">Country:</div>
                    <div class="col-sm-4 text-end">
                      {{ userDetails?.companyDetails?.country }}
                    </div>   
                  </div>
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg">City:</div>
                    <div class="col-sm-2">
                      {{ userDetails?.companyDetails?.city }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          
          
          <div class="col-sm-6">
            <div class="border">
              <div class="text-start border-bottom p-3 d-flex justify-content-between align-items-center bg-blue">
                <h6 class="d-inline my-auto">Contact</h6>
              </div>
              <div>
                <div class="card-body d-flex flex-column subscription-body p-3">
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg" >Name:</div>
                    <div class="col-sm-10  text-nowrap text-end">
                      {{ userDetails?.primaryUser?.firstName }}
                      {{ userDetails?.primaryUser?.lastName }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg">Job Title:</div>
                    <div class="col-sm-10  text-nowrap text-end">
                      {{ userDetails?.primaryUser?.jobTitle }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg">Phone:</div>
                    <div class="col-sm-10  text-nowrap text-end">
                      {{ userDetails?.primaryUser?.phoneNumber }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-2 fw-bold lh-lg">Email:</div>
                    <div class="col-sm-10  text-nowrap text-end">
                      {{ userDetails?.primaryUser?.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


              <div *ngIf="isSubscriptionLoaded && hideNonHostedEnvironmentMenus()" class="inner-container col-12"  >
                <app-table
                class=" mt-5"
                [isSupportQuotation]="false"
                [isNonHostedQuotation]="checkIfsubscriptionNonHosted()"
                [Enable24x7]="false"
                [isfromSales]="false"
                (headers)="handleUpdatedHeaders($event)"
                (updatedQuotationData)="handleUpdatedData($event)"
                (updatedFinalCost)="handleFinalCost($event)"
                [finalCost]="finalCost"
                [previewModeOn]="false"
                [subscriptionID]="this.subscriptionId"
                (enablePreview)="handleLocalPreview($event)"
                [cloudVendor]='this.cloudProvider'
                [cloudPlan]='this.cloudPlan'
                [planType] = "this.planType"
                [quotationEnvironmentsArray]="quotationEnvironmentsArray"
                [PreviewEnviromentsArray]="previewData"
                [serverProfiles]="serverProfiles"
                [regions]="regions"
                [availabilityZones]="availabilityZones"
                (OnRegionSelected)="handleAvalibilityZoneSelected($event)"
                (getEnvironmentPrices)="handleEnvironmentPrices($event)"
                (navigateBack)="handleNavigateBack()"
                [existingEnvironmentNames]="exisitingEnvironmentNames"
                (isQuotationDataBeingModified)="handlesQuotationDataBeingModified($event)"
                [isMidYearQuotation]="checkIfQuotationMidYear()"
                [quotationCategory]="categoryName"
                [nCacheVersion]="ncacheVersion"
                [operatingSystem]="operatingSystem"
                (get24x7quotationPrice)="handleGet24x7QuotationPrice($event)"
                (errorInQuotationTable)="handleErrorInQuotationTable($event)"
                (GetDiscounts)="handleDiscounts($event)"
                [enviromentTypes]="EnvironmentTypes"
                [subscriptionStatus]="subscriptionStatus"
                (errorInQuotationTable)="isErrorInQuotationTable($event)"
                [maxEnvironmentNameLength]="maxEnvLength"
                [isProfessionalQuotation] = 'checkIfPlanProfessional()'
                (isEnvironmentNameNotUnique)="isEnvironmentNameNotUnique($event)"
                >
                </app-table>

                
              
              </div>
              
      </div>
    </div>
  </div> -->

</app-content-body >

<div class='footer bg-light' fxLayoutGap="25px" *ngIf="isSubscriptionLoaded">

  <!-- <button *ngIf="hideNonHostedEnvironmentMenus()"
    class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
      (click)="back()">
      Previous
  </button>

  <button *ngIf="hideNonHostedEnvironmentMenus()"
    class="btn btn-nc me-3 btn-sm submit btn-primary btn-width"
    (click)="createPreview()"
    [disabled]="isError"
    >
      Preview
  </button> -->

  <button
      class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
      [routerLink]="['/subscription/dashboard']">
      Close
  </button>

</div>